export const ROUTES = {
  ANSWER_TEST: '/answer-test',
  ASSESSMENT: '/course/:courseGuid/lesson/:lessonGuid/assessment/:assessmentGuid',
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGIN_TOKEN: '/auth/login/:token',
  AUTH_SIGNUP: '/auth/signup',
  CALENDAR: '/calendar',
  CALENDAR_COURSE: '/calendar/:course',
  CONTENT: '/course/:courseGuid/lesson/:lessonGuid/content/:contentGuid',
  COURSE: '/course/:guid',
  COURSE_GRADES: '/course/:guid/grades',
  COURSE_PROGRAM: '/course/:guid/program',
  COURSE_HOME: '/course/:guid/home',
  COURSE_RESOURCES: '/course/:guid/resources',
  COURSE_CLASSROOM_RESOURCES: '/course/:guid/classroom-resources',
  CROSS_GRADEBOOK: '/cross-gradebook',
  DEEPLINK: '/deeplink',
  DEEPLINK_TOKEN: '/auth/login/:token/deeplink',
  ERROR: '/error',
  RESOURCES_PAGE: '/course/:guid/resources/:idResourcesSection/:idResourcesGroup',
  GROUP_RESOURCES_PAGE: '/course/:guid/resources/:idResourcesSection/:idResourcesGroup',
  HOME: '/home',
  KANBAN: '/course/:courseGuid/kanban/:lessonGuid',
  LEMON_TEST: '/lemon-test',
  LESSON: '/course/:courseGuid/lesson/:lessonGuid',
  LESSON_SESSION: '/course/:courseGuid/lesson/:lessonGuid/session/:sessionId',
  LICENSE: '/license',
  LOGOUT: '/logout',
  NEW_CONTENT: '/course/:courseGuid/lesson/:lessonGuid/new-content',
  ADD_ITEM: '/course/:courseGuid/lesson/:lessonGuid/add/:itemType',
  EDIT_ITEM: '/course/:courseGuid/lesson/:lessonGuid/edit/:itemGuid',
  NEW_QUESTION: '/course/:courseGuid/lesson/:lessonGuid/assessment/:assessmentGuid/new-question/:lemonadeType',
  NOT_FOUND: '*',
  OIDC_CALLBACK: '/oidc/callback/:token',
  PRIVACY: '/privacy',
  PROFILE: '/profile',
  CREDITS: '/credits',
  PROJECTION: '/course/:courseGuid/lesson/:lessonGuid/projection',
  PROJECTION_UNIT: '/course/:courseGuid/unit/:unitGuid/lesson/:lessonGuid/projection',
  PROJECTION_POWER: '/course/:courseGuid/lesson/:lessonGuid/projection/:unitGuid/power',
  PROJECTION_MINT: '/course/:courseGuid/lesson/:lessonGuid/projection/:unitGuid',
  PROJECTION_QUESTION: '/projection/question/:contentGuid',
  PROJECTION_TEST: '/projection/test/:contentGuid',
  PROJECTION_VIDEOLESSON: '/projection/videolesson/:contentGuid',
  QUESTION: '/course/:courseGuid/lesson/:lessonGuid/assessment/:assessmentGuid/question/:contentGuid',
  RECOVER_PASSWORD: '/recover-password',
  REMOTE: '/remote/:shortToken',
  RESOURCE: '/course/:courseGuid/lesson/:lessonGuid/resource/:itemGuid',
  RESULTS_ASSESSMENT: '/course/:courseGuid/lesson/:lessonGuid/results-assessment/:assessmentGuid',
  RESULTS_ASSESSMENT_2: '/results-assesment/:guid',
  RESULTS_ASSESSMENT_INVIDIDUAL: '/results-assesment-individual/course/:courseGuid/:assessmentGuid/user/:userGuid',
  RESULTS_ASSESSMENT_QUESTION_INDIVIDUAL: '/results-assesment-individual/course/:courseGuid/:assessmentGuid/user/:userGuid/question/:questionGuid',
  RESULTS_SCORM: '/course/:courseGuid/results-scorm/:itemGuid',
  RESULTS_SCORM_INDIVIDUAL: '/results-scorm-individual/:itemGuid/user/:userGuid',
  RESULTS_XAPI: '/course/:courseGuid/results-xapi/:itemGuid',
  RESULTS_XAPI_INDIVIDUAL: '/results-xapi-individual/:itemGuid/user/:userGuid',
  SAML_CALLBACK: '/saml/callback/:token',
  SAML_ERROR: '/saml/callback/error',
  SINGLE_ACTIVITY: '/single-activity/:courseGuid/:lessonItemGuid/:contentGuid',
  SINGLE_ACTIVITY_RECORD: '/single-activity/:courseGuid/record/:contentGuid/:referenceGuid',
  TASKS: '/tasks',
  TEAMS_CONFIG: '/config',
  TEAMS_TAB_AUTH_END: '/tab-auth-end',
  TEAMS_TAB_AUTH_START: '/tab-auth-start',
  TERMS: '/terms',
  TEST_COMPONENT: '/test-component',
  TOOLS: '/tools/:courseProjectGuid',
  UI: '/ui',
  UNIT_LESSON: '/course/:courseGuid/unit/:unitGuid/lesson/:lessonGuid',
  VIEWER: '/viewer/:guid',
  VIEWER_V1: '/viewer-v1/:guid',
  VIEWER_GROUP_RESOURCES: '/viewer/:guid/group-resources-view--visor',
  VIEWER_FULL: '/viewerfull/:guid',
  VIEWER_FULL_V1: '/viewerfull-v1/:guid',
  VIEWER_NUTRIENT_STANDALONE: '/viewer-nutrient-standalone/:guid',
  RESET_PASSWORD: '/reset-password',
  CHATBOT_PRACTICE: '/chatbot-practice',
  CHATBOT_PRACTICE_SESSION_ACTIVITY: '/activities/sessions/:sessionId/activities/:activityInstanceId',
  CHATBOT_PRACTICE_SESSION_SUMMARY: '/activities/sessions/:sessionId/summary',
  LIBRARY: '/library',
  RADAR: '/radar',
  STUDENT_KC_PROGRESS: '/radar/students/:userId/kcs/:kcId',
  TEACHER_ANALYTICS_BASE: '/analytics',
  TEACHER_ANALYTICS: '/analytics/:classId',
  TEACHER_TOOLS: '/teacher-tools',
  TEACHER_TOOLS_HISTORY: '/teacher-tools/history',
  TEACHER_TOOL_REAL_WORLD: '/teacher-tools/setup/real-world-connection',
  TEACHER_TOOL_TEXT_ADAPTER: '/teacher-tools/setup/text-level-adapter',
  TEACHER_TOOL_LESSON_PLAN: '/teacher-tools/setup/lesson-plan-generator',
  TEACHER_TOOL_RUBRIC: '/teacher-tools/setup/rubric-generator',
  TEACHER_TOOL_VOCABULARY: '/teacher-tools/setup/vocabulary-creator',
  TEACHER_TOOL_TRANSLATOR: '/teacher-tools/setup/text-translator',
  TEACHER_TOOL_FEEDBACK: '/teacher-tools/setup/student-feedback',
  TEACHER_TOOL_QUESTION: '/teacher-tools/setup/question-generator',
  TEACHER_TOOL_ENERGIZER: '/teacher-tools/setup/classroom-energizer',
  TEACHER_TOOL_INSTANCE: '/teacher-tools/instance/:toolInstanceId',
  STATUS: '/status',
};
